<template>
  <div>
    <section class="masthead masthead--inner">
      <div class="in">
        <div class="masthead__slide" style="background: url('../../../../../../static/styles/mailkit/img/banner.jpg') center center / cover no-repeat; width: 100%; display: inline-block;">
          <div class="masthead__caption">
            <h3>
              The Mailing Expert, the UK’s only instant franking machine comparison website.​
            </h3>
            <p style="font-size: 24px; max-width: none">Compare costs for all manufacturers and machines in minutes!</p>
          </div>
        </div>
      </div>
    </section>

    <div class="frankinForm__stepOne step">
      <div
        class="frankinForm__saveProgress saveProgress saveProgress--full saveProgress--paddingLarge"
        style="margin-top:0;"
        v-if="machines_amount === null"
      >
        <section class="formIntro">
          <div class="in container">
            <h4 id="getStarted">Let’s get started!</h4>
            <p>
              You are just a few minutes away from your franking machine quote.
            </p>
            <p>
              We search and compare all manufacturer models in the market place
              e.g. Pitney Bowes, Quadient (Neopost), FP and Frama. No need to speak to
              salespeople and filter out what is actually best for your
              business, we provide the facts with a full savings and return on
              investment calculation.
            </p>
            <p>
              Its important you answer all questions to the best of your
              ability, the detail entered will be used to calculate your
              savings, return on investment summary and provide you with a
              choice of suitable solutions from each manufacturer relevant to
              your specific business requirements.
            </p>

            <p><strong>Not a fan of forms? Click here to request a call back and have one of our Mailing Experts
              provide a quote for you.</strong></p>

            <p>Top tip: If you are currently in a contract, please have this handy to answer any questions our
              Expert may have.</p>

            <a href="/quotes-create?form=callback" class="btn btn-col" style="color:#0a70e3;">
              Request a call back
            </a>

            <a
              href="#"
              class="btn btn--base"
              tabindex="0"
              v-if="currentStep > 1"
              @click="stepBack"
              >Go Back</a
            >
          </div>
        </section>
        <div class="in container">
          <div class="saveProgress__content">
            <h4>How many offices/machines do you require a quote for?</h4>
            <p></p>
          </div>
          <div class="saveProgress__form">
            <div
              class="saveProgress__inputBlock"
              style="width:21.5625rem;margin:0 auto"
            >

              <div class="inputSelect" style="margin-top:10px;" tabindex="0">
                {{ machines_amount_view || "Please Select" }}

                <select
                  name="postagespendpermonth"
                  v-model="machines_amount_view"
                  style="position: absolute; top: 0; left: 0; opacity: 0;"
                >
                  <option disabled value="null">Please Select</option>
                  <option :value="1">1</option>
                  <option :value="2">2</option>
                  <option :value="3">3</option>
                  <option :value="4">4</option>
                  <option :value="5">5</option>
                  <option :value="6">6</option>
                  <option :value="7">7</option>
                  <option :value="8">8</option>
                  <option :value="9">9</option>
                  <option :value="10">10+</option>
                </select>
              </div>
            </div>
            <input
              id="step1continue"
              type="submit"
              value="Continue"
              @click.prevent="setMachinesAmount()"
              :disabled="machines_amount"
              onclick="window.scrollTo(0, 0);"
            />
          </div>
        </div>
      </div>

      <form-machines-amount-over-10
        v-if="machines_amount && machines_amount >= 2"
      ></form-machines-amount-over-10>

      <form-machines-amount-under-10
        v-if="machines_amount && machines_amount < 2"
      ></form-machines-amount-under-10>

      <div class="in container">
        <invalid-fields-modal></invalid-fields-modal>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState, mapMutations, mapActions } from "vuex";
import Form_MachinesAmountUnder10 from "./Conditionals/Form_MachinesAmountUnder10.vue";
import Form_MachinesAmountOver10 from "./Conditionals/Form_MachinesAmountOver10.vue";
import InvalidFieldsModal from "../InvalidFieldsModal.vue";

export default {
  components: {
    "form-machines-amount-under-10": Form_MachinesAmountUnder10,
    "form-machines-amount-over-10": Form_MachinesAmountOver10,
    "invalid-fields-modal": InvalidFieldsModal
  },

  data() {
    return {
      machines_amount_view: null,
      invalid_fields: false
    };
  },
  computed: {
    ...mapState("QuoteForm", ["step1", "quote_id", "currentStep"]),
    machines_amount: {
      get() {
        this.machines_amount_view = this.step1.machines_amount;
        return this.step1.machines_amount;
      }
    },
    email: {
      get() {
        return this.step1.email;
      },
      set(value) {
        this.updateStep1({ email: value });
        this.updateFormData({ email: value });
      }
    }
  },

  methods: {
    ...mapMutations("QuoteForm", ["updateStep1"]),
    ...mapMutations("LeadForm", ["updateFormData"]),
    ...mapActions("QuoteForm", ["createQuote", "updateQuote"]),

    setMachinesAmount() {
      this.updateStep1({ machines_amount: this.machines_amount_view });
      this.updateFormData({ machines: this.machines_amount_view });
    },
    submitQuote() {
      if (this.quote_id) {
        this.updateQuote(1);
      } else {
        this.createQuote();
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/views/Quotes/Form/Step-1/Form.vue